import React, { useContext } from 'react'
import LocalLink from './LocalLink'
import LayoutContext from './LayoutContext'
import { StyledButton } from './ButtonStyled'

const Button = ({
    children,
    href,
    buttonLink,
    textalign,
    tinted,
    secondary,
    full,
    largewhite,
    fluid,
    linkstyle,
    ...props
}: {
    children?: any
    href?: string
    buttonLink?: object
    textalign?: string
    tinted?: boolean
    secondary?: boolean
    full?: boolean
    largewhite?: boolean
    fluid?: boolean
    linkstyle?: boolean
}) => {
    const ButtonProps = {
        $textalign: textalign,
        $tinted: tinted,
        $secondary: secondary,
        $full: full,
        $largewhite: largewhite,
        $fluid: fluid,
        $linkstyle: linkstyle,
    }

    const { setSidebarOpen } = useContext(LayoutContext)

    return (
        <>
            {buttonLink ? (
                buttonLink.internalLink && buttonLink.internalLink.slug ? (
                    <StyledButton as={LocalLink} to={buttonLink.internalLink.slug} {...ButtonProps} {...props}>
                        {children}
                    </StyledButton>
                ) : buttonLink.internalFile ? (
                    <StyledButton
                        href={buttonLink.internalFile.file.url ? buttonLink.internalFile.file.url : undefined}
                        as={buttonLink.internalFile ? 'a' : 'button'}
                        target={buttonLink.internalFile && '_blank'}
                        {...ButtonProps}
                        {...props}
                    >
                        {children}
                    </StyledButton>
                ) : (
                    <StyledButton
                        href={buttonLink.externalLink ? buttonLink.externalLink : undefined}
                        as={buttonLink.externalLink && buttonLink.externalLink !== '#contact' ? 'a' : 'button'}
                        target={buttonLink.externalLink && '_blank'}
                        {...ButtonProps}
                        {...props}
                        {...(buttonLink.externalLink == '#contact'
                            ? {
                                  onClick: () => {
                                      setSidebarOpen(true)
                                  },
                              }
                            : undefined)}
                    >
                        {children}
                    </StyledButton>
                )
            ) : (
                <StyledButton {...ButtonProps} {...props}>
                    {children}
                </StyledButton>
            )}
        </>
    )
}

export default Button
